import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step6 } from '../../../../shared/models/component-messages/mapaIN/step6';
import { CTRL_18 } from '../../../validators/18/ctrl18';
import { CTRL_19 } from '../../../validators/19/ctrl19';
import { CTRL_20 } from '../../../validators/20/ctrl20';
import { CTRL_430 } from '../../../validators/430/ctrl430';
import { TypeDureeMarche } from '../models/TypeDureeMarche';
import { MapaINControlNames } from '../service/mapaINControleNames';
@Component({
  selector: 'app-type-duree-marche',
  templateUrl: './type-duree-marche.component.html',
  styleUrls: ['./type-duree-marche.component.scss']
})
export class TypeDureeMarcheComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeDureeMarche';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() typeDureeMarche: TypeDureeMarche;

  public rg1 = CTRL_430.id + '_4';
  public rg2 = CTRL_430.id + '_5';
  public rg3 = CTRL_19.id + '_1';
  public rg4 = CTRL_20.id + '_1';
  public rg7 = CTRL_18.id + '_1';

    public step6 = new Step6();

  constructor() { }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_433Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_434Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_19Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_20Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg7, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_16Names_json() }));
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }
  
  
}

